import "./PlotDatePicker.scss";
import { useEffect, useState } from "react";
import { Label } from "../../components/Label/Label";
import { Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useClickOutside from "../../hook/useClickOutside";
import moment from "moment";
import { CalculatorFill, Calendar } from "react-bootstrap-icons";
import { toast } from "react-toastify";
import HelperService from "../../utility/HelperService";
const ReactDatePickerComponent = DatePicker as unknown as React.FC<any>;

interface PlotDateRangePickerPropType {
    start_date: Date | null;
    end_date: Date | null;
    onDateChange: (start_date: Date | null, end_date: Date | null) => void;
}

const PlotDateRangePicker = (props: PlotDateRangePickerPropType) => {
    const [fromDate, setFromDate] = useState<Date | null>(() => {
        const today = new Date();
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 7);
        return sevenDaysAgo;
    });
    const [toDate, setToDate] = useState<Date | null>(new Date());
    const [isShowDateRange, setIsShowDateRange] = useState(false);
    const [dateFilterBy, setDateFilterBy] = useState('THIS_WEEK');
    const [fromLeft, setFromLeft] = useState(0);
    const [toLeft, setToLeft] = useState(0);

    useEffect(() => {
        setFromDate(props.start_date);
        setToDate(props.end_date);
    }, [props.start_date, props.end_date]);


    let domNode = useClickOutside(() => {
        setIsShowDateRange(false)
        setFromDate(props.start_date)
        setToDate(props.end_date)
    }, this);

    const OnSelectDateRange = (type: string) => {
        setDateFilterBy(type)
        if (type === 'THIS_WEEK') {
            var startOfWeek = moment().startOf('week').toDate()
            var endOfWeek = moment().endOf('week').toDate()
            setFromDate(startOfWeek)
            setToDate(endOfWeek)
            // props.onDateChange(startOfWeek, endOfWeek)
        } else if (type === 'TODAY') {
            var today = moment().startOf('day').toDate()
            var endOfToday = moment().endOf('day').toDate()
            setFromDate(today)
            setToDate(endOfToday)
            // props.onDateChange(today, endOfToday)
        } else if (type === 'YESTERDAY') {
            var yesterday = moment().subtract(1, 'days').toDate()
            setFromDate(yesterday)
            setToDate(yesterday)
            // props.onDateChange(yesterday, yesterday)
        } else if (type === 'THIS_MONTH') {
            var date = new Date()
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
            setFromDate(firstDay)
            setToDate(lastDay)
            // props.onDateChange(firstDay, lastDay)
        } else if (type === 'LAST_MONTH') {
            var date = new Date()
            const firstDayPrevMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1)
            const lastDayPrevMonth = new Date(date.getFullYear(), date.getMonth(), 0)
            setFromDate(firstDayPrevMonth)
            setToDate(lastDayPrevMonth)
            // props.onDateChange(firstDayPrevMonth, lastDayPrevMonth)
        } else if (type === 'LAST_YEAR') {
            var lastyear = new Date(new Date().getFullYear() - 1, 0, 1)
            var start = new Date(lastyear.getFullYear(), 0, 1)
            var end = new Date(lastyear.getFullYear(), 11, 31)
            setFromDate(start as any)
            setToDate(end as any)
            // props.onDateChange(start as any, end as any)
        } else if (type === 'FINANCIAL_YEAR') {
            var start = new Date(new Date().getFullYear(), 3, 1)
            var end = new Date(new Date().getFullYear() + 1, 2, 31)
            setFromDate(start as any)
            setToDate(end as any)
            // props.onDateChange(start as any, end as any)
        } else if (type === 'LAST_FINANCIAL_YEAR') {
            var start = new Date(new Date().getFullYear() - 1, 3, 1)
            var end = new Date(new Date().getFullYear(), 2, 31)
            setFromDate(start as any)
            setToDate(end as any)
            // props.onDateChange(start as any, end as any)
        } else {
            setFromDate(null as any)
            setToDate(null as any)
        }
    }

    const onDateFiltering = () => {
        setIsShowDateRange(!isShowDateRange)
        // setFromDate(startDate)
        // setToDate(endDate)
        // // props.onSort(1, isAscending, key, startDate, endDate, filters, dateFilter)
        // if (!fromDate || !toDate) {
        //     toast.error("Please select start date and end date")
        //     return
        // };
        props.onDateChange(
            fromDate ? moment(fromDate).startOf('day').toDate() : null,
            toDate ? moment(toDate).endOf('day').toDate() : null
        )
    };

    return (
        <>
            <div className="date-range-picker">
                <div className="form-style ms-2 mt-1 w-100 duration-dropdown text-end">
                    <Button
                        variant="light"
                        className="btn-brand-light w-100"
                        onClick={(e: any) => {
                            setIsShowDateRange(!isShowDateRange)
                            // var startOfWeek = moment().startOf('week').toDate()
                            // var endOfWeek = moment().endOf('week').toDate()
                            // setFromDate(startOfWeek)
                            // setToDate(endOfWeek)
                            setFromLeft(e.clientX)
                            setToLeft(e.clientX + 150)
                        }}
                    >
                        {' '}
                        {/* <img src={iconCalendar} height={16} width={16} className="icon" /> */}
                        {fromDate && toDate ? `${HelperService.getFormatedDate(fromDate)} - ${HelperService.getFormatedDate(toDate)}` : <> <Calendar /> Select Date Range</>}
                    </Button>

                    {isShowDateRange ? (
                        <ul ref={domNode} id="dateRangeId" className="date-range-submenu" style={{ right: `calc(100% - ${toLeft}px)` }}>
                            <li>
                                <div className="row date-picker-border">
                                    <div className="col-3  left-border">
                                        <div onClick={() => OnSelectDateRange('TODAY')}>
                                            <Label
                                                title="Today"
                                                classNames={
                                                    dateFilterBy === 'TODAY'
                                                        ? 'mt-2 mb-2 date-filter-by-selected'
                                                        : 'mt-2 mb-3 date-filter-by'
                                                }
                                            />{' '}
                                        </div>
                                        <div onClick={() => OnSelectDateRange('YESTERDAY')}>
                                            <Label
                                                title="Yesterday"
                                                classNames={
                                                    dateFilterBy === 'YESTERDAY'
                                                        ? 'mt-2 mb-2 date-filter-by-selected'
                                                        : 'mt-2 mb-3 date-filter-by'
                                                }
                                            />{' '}
                                        </div>
                                        <div onClick={() => OnSelectDateRange('THIS_WEEK')}>
                                            <Label
                                                title="This Week"
                                                classNames={
                                                    dateFilterBy === 'THIS_WEEK'
                                                        ? 'mt-2 mb-2 date-filter-by-selected'
                                                        : 'mt-2 mb-3 date-filter-by'
                                                }
                                            />{' '}
                                        </div>
                                        <div onClick={() => OnSelectDateRange('THIS_MONTH')}>
                                            <Label
                                                title="This Month"
                                                classNames={
                                                    dateFilterBy === 'THIS_MONTH'
                                                        ? 'mb-2 date-filter-by-selected'
                                                        : 'mb-3  date-filter-by'
                                                }
                                            />{' '}
                                        </div>

                                        <div onClick={() => OnSelectDateRange('LAST_MONTH')}>
                                            <Label
                                                title="Last Month"
                                                classNames={
                                                    dateFilterBy === 'LAST_MONTH'
                                                        ? 'mb-3 date-filter-by-selected'
                                                        : 'mb-3  date-filter-by'
                                                }
                                            />{' '}
                                        </div>
                                        <div onClick={() => OnSelectDateRange('FINANCIAL_YEAR')}>
                                            <Label
                                                title="Financial Year"
                                                classNames={
                                                    dateFilterBy === 'FINANCIAL_YEAR'
                                                        ? 'mb-3 date-filter-by-selected'
                                                        : 'mb-3  date-filter-by'
                                                }
                                            />{' '}
                                        </div>
                                        <div onClick={() => OnSelectDateRange('LAST_FINANCIAL_YEAR')}>
                                            <Label
                                                title="Last Financial Year"
                                                classNames={
                                                    dateFilterBy === 'LAST_FINANCIAL_YEAR'
                                                        ? 'mb-3 date-filter-by-selected'
                                                        : 'mb-3  date-filter-by'
                                                }
                                            />{' '}
                                        </div>
                                        <div onClick={() => OnSelectDateRange('CUSTOM_RANGE')}>
                                            <Label
                                                title="Custom Range"
                                                classNames={
                                                    dateFilterBy === 'CUSTOM_RANGE'
                                                        ? 'mb-3 date-filter-by-selected'
                                                        : 'mb-3  date-filter-by'
                                                }
                                            />{' '}
                                        </div>
                                    </div>
                                    <div className="col-9 ">
                                        <div className="row mb-3">
                                            <div className="col-6 ">
                                                <Label title="Start Date" classNames="text-dark" />
                                                <div className="input-group input-group-sm bg-transparent" style={{ width: "90%" }}>
                                                    <input
                                                        type="text"
                                                        disabled
                                                        className="form-control mt-0 bg-light border-end-0 text-dark bg-transparent"
                                                        value={fromDate ? moment(fromDate).format('MM/DD/YYYY') : null as any}
                                                    />
                                                    <span
                                                        className="input-group-text bg-transparent mt-0 border-start-0 theme-icon-color"
                                                        id="basic-addon2"
                                                    >
                                                        <Calendar />
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <Label title="End Date" classNames="text-dark" />
                                                <div className="input-group input-group-sm bg-transparent" style={{ width: "90%" }}>
                                                    <input
                                                        type="text"
                                                        disabled
                                                        className="form-control mt-0 bg-light border-end-0 text-dark bg-transparent"
                                                        value={toDate ? moment(toDate).format('MM/DD/YYYY') : null as any}
                                                    />
                                                    <span
                                                        className="input-group-text bg-transparent mt-0 border-start-0"
                                                        id="basic-addon2"
                                                    >
                                                        <Calendar />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className=" row ">
                                            <div className="col-6 ">
                                                <div>
                                                    <ReactDatePickerComponent
                                                        selected={fromDate}
                                                        onChange={(date: any) => setFromDate(date)}
                                                        minDate={dateFilterBy == 'CUSTOM_RANGE' ? undefined : fromDate}
                                                        maxDate={dateFilterBy == 'CUSTOM_RANGE' ? undefined : fromDate}
                                                        inline
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        renderInput={() => null}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <ReactDatePickerComponent
                                                    selected={toDate}
                                                    onChange={(date: any) => setToDate(date)}
                                                    minDate={dateFilterBy == 'CUSTOM_RANGE' ? '' : toDate}
                                                    maxDate={dateFilterBy == 'CUSTOM_RANGE' ? '' : toDate}
                                                    readOnly={dateFilterBy == 'CUSTOM_RANGE' ? false : true}
                                                    inline
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    renderInput={() => null}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12  mt-3 text-center">
                                            <Button
                                                variant="primary"
                                                className="btn-brand-solid me-3 mb-0"
                                                type="submit"
                                                onClick={() => onDateFiltering()}
                                            >
                                                Apply
                                            </Button>
                                            <Button
                                                variant="primary"
                                                className="btn-brand-outline me-3"
                                                type="button"
                                                onClick={() => {
                                                    setDateFilterBy('')
                                                    setFromDate(null)
                                                    setToDate(null)
                                                    setIsShowDateRange(false)
                                                    props.onDateChange(null, null)
                                                }}
                                            >
                                                Reset
                                            </Button>
                                            <Button
                                                variant="primary"
                                                className="btn-brand-outline"
                                                type="button"
                                                onClick={() => {
                                                    setIsShowDateRange(!isShowDateRange)
                                                    setFromDate(props.start_date)
                                                    setToDate(props.end_date)
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    ) : (
                        ''
                    )}

                </div>
            </div>
        </>
    );
};

export default PlotDateRangePicker;
